window.ttx = window.ttx || {};
ttx.script = {};

/**
 * 执行原始脚本代码，包装为 defineInner 模块后执行，并调用 MyExternal.init(vm)
 * 用户的扩展代码插入到 MyExternal.init 的 try 块中
 * @param {string} scriptCode - 脚本编码
 * @param {string} scriptContent - 用户编写的扩展代码
 * @param {object} vm - ViewModel 实例
 */
ttx.script.execute = function (scriptCode, scriptContent, vm, opts) {
    if (!scriptContent || !vm) return;
    // 脚手架产物（main）：完整 webpack 模块，直接挂载执行，不套 MyExternal 包装
    var isMain = (opts && opts.main === true) || ttx.script.isMainModule(scriptContent);
    if (isMain) {
        ttx.script.mountMain(scriptCode, scriptContent, vm);
        return;
    }

    var cfg = (ttx.requirejs && ttx.requirejs.getConfig) ? ttx.requirejs.getConfig() : {};
    var scriptPrefix = cfg.scriptPrefix || 'ext/script/';
    var moduleName = scriptPrefix + scriptCode;
    ttx.log.info('[ttx.script] 执行脚本: ' + scriptCode + ' -> ' + moduleName);

    // 包装为完整的 defineInner 模块（框架壳 + 用户扩展代码）
    var code = 'ttx.defineInner("' + moduleName + '", [], function () {\n' +
        '    ttx.rest.invokeFunction = function (id, data, callback, viewModel, options) {\n' +
        '        if (!options) {\n' +
        '            var options = {};\n' +
        '            options.domainKey = ttx.utils.getActiveDomainKey();\n' +
        '        }\n' +
        '        if (options.domainKey == null && viewModel != undefined) {\n' +
        '            options.domainKey = viewModel.getDomainKey();\n' +
        '        }\n' +
        '        var proxy = ttx.rest.DynamicProxy.create({\n' +
        '            doProxy: {\n' +
        '                url: "/web/function/invoke/" + id,\n' +
        '                method: "POST",\n' +
        '                options: options\n' +
        '            }\n' +
        '        });\n' +
        '        if (options.async == false) {\n' +
        '            return proxy.doProxy(data, callback);\n' +
        '        } else {\n' +
        '            proxy.doProxy(data, callback);\n' +
        '        }\n' +
        '    };\n' +
        '    var MyExternal = {\n' +
        '        doAction: function (name, viewModel) {\n' +
        '            if (this[name]) {\n' +
        '                this[name](viewModel);\n' +
        '            }\n' +
        '        },\n' +
        '        init: function (viewModel) {\n' +
        '            try {\n' +
        scriptContent + '\n' +
        '            } catch (err) {\n' +
        '                ttx.utils.alert(err, "error");\n' +
        '            }\n' +
        '            if (viewModel.hasEvent("customInit")) {\n' +
        '                viewModel.execute("customInit", viewModel);\n' +
        '                return;\n' +
        '            }\n' +
        '        }\n' +
        '    }\n' +
        '    return MyExternal;\n' +
        '});\n' +
        '//# sourceURL=ext-script-' + scriptCode + '.js';

    var scriptEl = document.createElement('script');
    scriptEl.textContent = code;
    scriptEl.setAttribute('data-ext-script', scriptCode);
    document.head.appendChild(scriptEl);

    try {
        var ext = ttx.requireInner(moduleName);
        if (ext && typeof ext.init === 'function') {
            ttx.log.info('[ttx.script] 初始化脚本: ' + scriptCode);
            ext.init(vm);
            ttx.log.info('[ttx.script] 脚本 ' + scriptCode + ' 执行完成');
        }
    } catch (e) {
        ttx.console.error('[ttx.script.execute] 脚本 ' + scriptCode + ' 执行失败:', e);
    }
};

/**
 * 按 scriptId / scriptCode 取脚本内容并在前端执行（按钮「执行前端脚本」命令使用）
 * 脚本约定：exports.main(event, context)；未定义 main 时回退 init(vm)（兼容页面扩展脚本写法）
 */
ttx.script.run = function (opts) {
  var o = opts || {};
  var vm = o.vm;
  var event = o.event || {};
  var cache = ttx.script._contentCache = ttx.script._contentCache || {};

  function fetchContent(id, code) {
    var key = id ? ('id:' + id) : ('code:' + code);
    if (cache[key]) return Promise.resolve(cache[key]);
    return new Promise(function (resolve, reject) {
      ttx.ajax.xhrUtil({
        url: '/api/script/detail',
        method: 'get',
        data: id ? { id: id } : { code: code },
        showErrorToast: false,
        success: function (res) {
          var content = res?.data?.content || res?.content || '';
          if (!content) {
            reject(new Error('脚本内容为空'));
            return;
          }
          cache[key] = content;
          resolve(content);
        },
        error: function () {
          reject(new Error('脚本加载失败'));
        },
      });
    });
  }

  function execute(content) {
    var context = {
      ttx: ttx,
      vm: vm,
      event: event,
      execute: function (command, data) {
        return ttx.command.execute(command, Object.assign({ vm: vm }, data || {}));
      },
      openPage: function (options, cb) {
        return ttx.loader.openPage(options, vm, cb);
      },
      getValue: function (field) {
        return (vm?.getData?.() || {})[field];
      },
      setValue: function (field, value) {
        try {
          var model = vm?.get?.(field);
          if (model && typeof model.setState === 'function') model.setState({ value: value });
          var next = Object.assign({}, vm?.getData?.() || {}, { [field]: value });
          vm?._set_data?.('value', next, true);
          vm?.execute?.('modeChange', vm?._get_data?.('currentMode') || 'browse');
        } catch (e) {}
      },
      refresh: function () { vm?.execute?.('refresh'); },
      toast: ttx.toast,
      confirm: ttx.modal?.confirm,
      ajax: ttx.ajax,
    };
    var moduleObj = { exports: {} };
    var fn = new Function('exports', 'module', 'event', 'context', 'ttx', String(content) + '\n;return module.exports;');
    var out = fn(moduleObj.exports, moduleObj, event, context, ttx);
    var exp = out || moduleObj.exports;
    if (exp && typeof exp.main === 'function') return exp.main(event, context);
    if (exp && typeof exp.init === 'function') {
      exp.init(vm);
      return true;
    }
    return true;
  }

  return Promise.resolve()
    .then(function () {
      if (o.scriptId) return fetchContent(o.scriptId, '');
      if (o.scriptCode) return fetchContent('', o.scriptCode);
      throw new Error('缺少 scriptId 或 scriptCode');
    })
    .then(execute);
};

/**
 * 判断是否脚手架「main」模块（完整 webpack 产物）：扩展名 _min.js（extend_xxx_min.js）
 * 或内容为 webpack UMD 形态。是 main 则直接挂载、不走 MyExternal 包装。
 */
ttx.script.isMainModule = function (scriptContent) {
    var s = String(scriptContent || '');
    return (
        /webpackUniversalModuleDefinition/.test(s) ||
        /extend_[A-Za-z0-9_]+_min\.js/.test(s)
    );
};

/**
 * 直接挂载脚手架 main 模块：用脚本标签按内容执行（不套 MyExternal 包装）。
 * 执行时捕获 ttx.define 注册的领域模块，实例化后调用其 init(vm)，驱动业务代码运行。
 */
ttx.script.mountMain = function (scriptCode, scriptContent, vm) {
    ttx.log.info('[ttx.script] main 模块，直接挂载（不包装）: ' + scriptCode);

    var captured = null;
    var origDefine = ttx.define;
    if (typeof origDefine === 'function') {
        // 拦截 ttx.define，捕获脚手架注册的领域模块（name/deps/factory）
        ttx.define = function (name, deps, factory) {
            var args = arguments;
            try {
                if (typeof name === 'string' && typeof factory === 'function') {
                    captured = {
                        name: name,
                        deps: Array.isArray(deps) ? deps.slice() : [],
                        factory: factory,
                    };
                }
            } catch (e) {}
            return origDefine.apply(this, args);
        };
    }

    try {
        var el = document.createElement('script');
        el.textContent = scriptContent;
        el.setAttribute('data-ext-script', scriptCode);
        document.head.appendChild(el);
    } finally {
        if (origDefine) ttx.define = origDefine;
    }

    // 驱动业务：实例化捕获到的领域模块并调用 init(vm)
    if (vm && captured && captured.factory) {
        try {
            var mod = instantiateExtModule(captured);
            if (mod && typeof mod.init === 'function') {
                ttx.log.info('[ttx.script] 初始化 main 领域模块: ' + captured.name);
                mod.init(vm);
            }
        } catch (e) {
            ttx.log && ttx.log.warn && ttx.log.warn('[ttx.script] main 模块 init 失败: ' + captured.name + ' ' + (e && e.message));
        }
    }
};

/**
 * 实例化脚手架捕获到的领域模块：解析 factory 的依赖（支持 require/exports/module 伪依赖），
 * 兼容「return pageData」与「module.exports = pageData」两种写法。
 */
function instantiateExtModule(captured) {
    var exports = {};
    var moduleObj = { exports: {} };
    var depExports = [];
    for (var i = 0; i < captured.deps.length; i++) {
        var d = captured.deps[i];
        var resolved;
        if (d === 'require') {
            resolved = ttx.requireInner;
        } else if (d === 'exports') {
            resolved = exports;
        } else if (d === 'module') {
            resolved = moduleObj;
        } else {
            try {
                resolved = ttx.requireInner ? ttx.requireInner(d) : undefined;
            } catch (e) {
                resolved = undefined;
            }
        }
        depExports.push(resolved);
    }

    var ret = captured.factory.apply(window, depExports);
    if (ret) return ret;
    if (moduleObj.exports && Object.keys(moduleObj.exports).length) return moduleObj.exports;
    if (Object.keys(exports).length) return exports;
    return null;
}

/**
 * 按 @param scriptContent 加载页面关联的模板扩展脚本
 * @param {string} metaId - 页面 meta ID（templateId 有值时可为空）
 * @param {object} vm - ViewModel 实例
 * @param {string} [templateId] - 模板副本 ID（参照等场景：直接按 copy 模板加载脚本）
 * @returns {Promise<boolean>}
 */
ttx.script.loadPageScripts = function (metaId, vm, templateId) {
    if ((!metaId && !templateId) || !vm) return Promise.resolve(false);

    ttx.log.info('[ttx.script] 开始加载页面扩展脚本, metaId=' + metaId + ', templateId=' + (templateId || ''));

    return new Promise(function (resolve) {
        var reqData = { metaId: metaId || '' };
        if (templateId) reqData.templateId = templateId;
        ttx.ajax.xhrUtil({
            url: '/api/template/loadExtend',
            method: 'get',
            data: reqData,
            success: function (res) {
                var data = res?.data || {};

                var cfg = (ttx.requirejs && ttx.requirejs.getConfig) ? ttx.requirejs.getConfig() : {};
                var codePattern = cfg.scriptCodePattern || 'AT[A-F0-9]{16}';
                var codeRegex = new RegExp(codePattern);

                var urls = data.scriptUrls || [];
                if (urls.length) {
                    ttx.log.info('[ttx.script] 加载 scriptUrls: ' + urls.length + ' 个');
                }
                // 请求每个路径获取内容，用原生 XHR 拼接 script 前缀请求，execute 执行
                var platform = (ttx.ajax && ttx.ajax.config && ttx.ajax.config().script) || '';
                function loadNext(index, done) {
                    if (index >= urls.length) {
                        done();
                        return;
                    }
                    var url = urls[index];
                    var match = url.match(codeRegex);
                    var scriptCode = match ? match[0] : '';
                    var fullUrl = platform + url;
                    // 脚手架 main 模块：extend_xxx_min.js，走 URL 外链加载，不走 XHR 内联包装
                    var isMain = /extend_[^/]+_min\.js$/i.test(url);
                    // 缓存 scriptCode → 精确路径，供 loadExtScript 使用
                    if (scriptCode && ttx.requirejs && ttx.requirejs.cacheScriptUrl) {
                        ttx.requirejs.cacheScriptUrl(scriptCode, fullUrl);
                    }
                    if (isMain) {
                        loadMainByUrl(scriptCode, fullUrl, vm, function () {
                            loadNext(index + 1, done);
                        });
                        return;
                    }
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', fullUrl, true);
                    xhr.onload = function () {
                        if (xhr.status === 200 && xhr.responseText && scriptCode) {
                            ttx.script.execute(scriptCode, xhr.responseText, vm);
                        }
                        loadNext(index + 1, done);
                    };
                    xhr.onerror = function () {
                        ttx.log.warn('[ttx.script] 脚本加载失败: ' + fullUrl);
                        loadNext(index + 1, done);
                    };
                    xhr.send();
                }
                /**
                 * URL 外链加载脚手架 main 产物：<script src> 原生加载，脚本执行时拦截
                 * ttx.define 捕获领域模块，onload 后实例化并主动调用 init(vm) 驱动业务。
                 */
                function loadMainByUrl(scriptCode, fullUrl, vm, done) {
                    var captured = null;
                    var origDefine = ttx.define;
                    if (typeof origDefine === 'function') {
                        ttx.define = function (name, deps, factory) {
                            try {
                                if (typeof name === 'string' && typeof factory === 'function') {
                                    captured = {
                                        name: name,
                                        deps: Array.isArray(deps) ? deps.slice() : [],
                                        factory: factory,
                                    };
                                }
                            } catch (e) {}
                            return origDefine.apply(this, arguments);
                        };
                    }
                    var el = document.createElement('script');
                    el.type = 'text/javascript';
                    el.async = true;
                    el.src = fullUrl;
                    el.setAttribute('data-ext-script', scriptCode);
                    el.setAttribute('data-ext-main', '1');
                    var fin = false;
                    function finish() {
                        if (fin) return;
                        fin = true;
                        if (origDefine) ttx.define = origDefine;
                        if (vm && captured && captured.factory) {
                            try {
                                var mod = instantiateExtModule(captured);
                                if (mod && typeof mod.init === 'function') {
                                    ttx.log.info('[ttx.script] 初始化 main 领域模块: ' + captured.name);
                                    mod.init(vm);
                                }
                            } catch (e) {
                                ttx.log && ttx.log.warn && ttx.log.warn('[ttx.script] main 模块 init 失败: ' + captured.name + ' ' + (e && e.message));
                            }
                        }
                        done();
                    }
                    el.onload = finish;
                    el.onerror = function () {
                        ttx.log.warn('[ttx.script] main 脚本加载失败: ' + fullUrl);
                        finish();
                    };
                    document.head.appendChild(el);
                }
                // 异步链式加载所有脚本，完成后才继续处理 styles/rawScripts 并 resolve
                loadNext(0, function () {
                    loadStylesAndRaw();
                });

                function loadStylesAndRaw() {
                    var styles = data.styleUrls || [];
                    if (styles.length) {
                        ttx.log.info('[ttx.script] 加载 styleUrls: ' + styles.length + ' 个');
                    }
                    styles.forEach(function (url) {
                        var link = document.createElement('link');
                        link.rel = 'stylesheet';
                        link.href = url;
                        document.head.appendChild(link);
                    });

                    var rawScripts = data.rawScripts || [];
                    if (rawScripts.length) {
                        ttx.log.info('[ttx.script] 执行 rawScripts: ' + rawScripts.length + ' 个');
                    }
                    rawScripts.forEach(function (script) {
                        if (script.content) {
                            ttx.script.execute(script.scriptCode, script.content, vm);
                        }
                    });

                    ttx.log.info('[ttx.script] 页面扩展脚本加载完成');
                    resolve(true);
                }
            },
            error: function (err) {
                ttx.console.error('[ttx.script.loadPageScripts] 加载模板脚本失败:', err);
                resolve(false);
            }
        });
    });
};
